module.exports = __webpack_public_path__ + "static/fifth_user_image6-e8f584162b7225438c01fe2055a8ac63.jpg";